import React from "react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/Button";
import { Badge } from "../../components/ui/badge";
import { Eye, User } from "lucide-react";
const TicketCard = ({ ticket,statusConfig,getStatusName,priorityConfig,getPriorityName,setShowTicketDetails,getCategoryName }) => (
        <Card className="hover:shadow-md transition-shadow">
            <div className="p-6 space-y-4">
                {/* Header */}
                <div className="flex justify-between items-start">
                    <div>
                        <div className="flex items-center gap-2">
                            <Badge variant={undefined} className={statusConfig[Number(ticket?.status)]?.color}>
                                {getStatusName(Number(ticket.status))}
                            </Badge>
                            <Badge variant={undefined} className={priorityConfig[Number(ticket?.priority)]?.color}>
                                {priorityConfig[Number(ticket?.priority)]?.icon}
                                <span className="ml-1 capitalize">{getPriorityName(Number(ticket?.priority))}</span>
                            </Badge>
                        </div>
                        <h3 className="font-medium mt-2">{ticket?.subject}</h3>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => setShowTicketDetails(ticket)}>
                        <Eye className="h-4 w-4" />
                    </Button>
                </div>
                {/* Info Grid */}
                <div className="grid grid-cols-2 gap-4" style={{ textAlign: "left" }}>
                    <div>
                        <span className="text-sm text-gray-500">Category</span>
                        <p className="font-medium">{getCategoryName(Number(ticket.category))}</p>
                    </div>
                    <div>
                        <span className="text-sm text-gray-500">Created</span>
                        <p className="font-medium">{new Date(ticket.createdAt).toLocaleDateString()}</p>
                    </div>
                </div>

                {/* User Info */}
                <div className="flex items-center justify-between pt-4 border-t">
                    <div className="flex items-center gap-3">
                        <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                            <User className="h-4 w-4 text-gray-600" />
                        </div>
                        <div>
                            <p className="font-medium">{ticket.user.name}</p>
                            <p className="text-sm text-gray-500">{ticket.user.type}</p>
                        </div>
                    </div>
                    <div className="text-right">
                        <p className="text-sm font-medium">{ticket.assignedTo.name}</p>
                        <p className="text-sm text-gray-500">Assigned To</p>
                    </div>
                </div>
            </div>
        </Card>
    );
    export default TicketCard;